import React from 'react'

import { useParams } from 'react-router-dom'

import * as service from 'service'

const LoginToken = () => {
  const params = useParams()

  // this route only sets token to localstorage
  // AuthProvider responsible for:
  // - check if token is valid
  // - load user data
  // - redirect for main route
  React.useEffect(() => {
    const recurrenceAuthToken = params.recurrenceAuthToken
    service.storage.setRecurrenceAuthToken(recurrenceAuthToken)
  }, [params.recurrenceAuthToken])

  return <div></div>
}

export default LoginToken
